import About from "../components/About";
import Contact from "../components/Contact";
import Hero from "../components/Hero";

export default function Home() {
  return (
    <main className="overflow-hidden">
      <Hero />
      <About />
      <Contact />
    </main>
  );
}
